import { getPageData } from "services/craft/craft"
import runMiddleware from "lib/runMiddleware"
import Layout from "components/layout/layout"

export default function Home(props) {
    const colorMode = props.page.colorMode || "dark"

    return (
        <Layout
            className={"colorMode--" + colorMode + " home"}
            site={props.site}
            page={props.page}
            slug={props.slug}
            matrix={props.page.matrix}
            user={props.user}
            colorMode={colorMode}
            channels={props.channels}
            craftSiteId={props.site.meeting.siteId}
            hideSocialFooter={true}
            layoutVariant={props.layoutVariant}
            // pageAd={pageAd}
            // bgStyles={bgStyles}
        />
    )
}

export const getServerSideProps = runMiddleware(async function ({ req, res, params, locale, query, user }) {
    // these headers invoke SWR to provide a cache-like experience
    res.setHeader("Cache-Control", "public, s-maxage=1, stale-while-revalidate=59")

    const data = await getPageData({
        locale: locale,
        page: {
            slug: query?.hasOwnProperty("path") ? query.path : "home-page",
            type: "homePage",
        },
        query: query,
    })

    // page not found, return 404
    if (!data.page) {
        return {
            notFound: true,
        }
    }

    data.page.showPageHeader = false

    return {
        props: {
            section: "homePage",
            title: data.page.title,
            matrix: data.page.matrix,
            page: data.page,
            site: data.site,
            locale: locale,
            pageStatus: data.page.userStatus,
            user: user,
        },
    }
})
